import {InspectionUpdate} from "../../javaTypes";
import {t} from "../../i18n";
import './StatusLegend.css'

export default function StatusLegend({inspectionData, projector} : {
    inspectionData?: InspectionUpdate,
    projector?: boolean
}) {
    if (!inspectionData?.forms) {
        return <></>
    }
    const formNames = [<th key={0}>{t`Name`}</th>, ...inspectionData.forms.map(form => <td key={form.code}>{form.name}</td>)];
    const statusNames = [<th key={0}>{t`Status`}</th>, ...inspectionData.statuses.map(status => <td key={status.name}>{status.displayName}</td>)];
    const formSymbols = [<th key={0}>{t`Symbol`}</th>, ...inspectionData.forms.map(form => <td key={form.abbrev}>{form.abbrev.toUpperCase()}</td>)];
    const statusColors = [<th key={0}>{t`Color`}</th>, ...inspectionData.statuses.map(status => <td key={status.name} style={{backgroundColor: status.color}}>&nbsp;</td>)];

    if (projector) { // for projector view - two legends in 1 row since vertical space is premium
        return <table className={"status-table ml-auto mr-auto"}>
            <tr>{formNames}{statusNames}</tr>
            <tr>{formSymbols}{statusColors}</tr>
        </table>
    }
    // For non-projector view, split the legend into 2 tables.
    return <>
        <table className={"status-table form-legend-table ml-auto mr-auto"}>
            <tr>{formNames}</tr>
            <tr>{formSymbols}</tr>
        </table>
        <table className={"status-table status-legend-table ml-auto mr-auto"} style={{marginTop: "5px"}}>
            <tr>{statusNames}</tr>
            <tr>{statusColors}</tr>
        </table>
    </>
}